const $ = require('jquery');
import _ from 'underscore';
import run from '../../utilities/run';
import DetailsTab from './detailsTab.js';
import AddressTab from './addressTab.js';
import OperationsTab from './operationsTab.js';
import ReviewTab from './reviewTab.js';
import CalendarTab from './calendarTab.js';
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import addressValidationFactory from '../common/AddressValidation.js';
import {convertMilitaryToInt} from "../../utilities/general";
import EditChecker from '../../components/EditChecker/EditChecker';


 // For quick dev prototyping
run("#standard-platform-facility-setup-wizard", (mainEl)=>{
  attachWizard(mainEl);
  setupEditChecker();
});

function setupEditChecker(){
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener("#standard-platform-facility-setup-wizard");
  EditChecker.bindChangeListener("span.select2");
  EditChecker.bindCancelButton("#spl-cancel-url");
}

function attachWizard(el){
  const validator = el.validate({
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      let appendTo = $(element).data('error-placement-append-to');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      }else if (appendTo) {
        $(appendTo).append(error);
      }else {
        error.insertAfter(element);
      }
    }
    // Place all your validation rules here!!!
    // rules: {
    // }
  });

  validator.settings.ignore = ":disabled,:hidden";
  const quickWizard = new QuickWizard(el, {
    tabletWidthNavStep: 1090,
    mobileWidthNavStep: 950,
    customRules: {
      ".facility-uses-section": {
        errorMessageSelector: "#details-tab-fac-ownership-error",
        isValid: (validSelection, done)=>{
          if(validSelection){
            let checked = $(".facility-uses-section input:radio:checked").length > 0;
            
            if(!checked){
              done(false, {displayErrors: true});
            }else{
              done(true, {displayErrors: true});
            }
          }else{
            done(true, {displayErrors: true});
          }
          return done;
        } 
      }
    },
    shouldNavigateToForm: ({targetForm, direction, currentForm, done})=>{
     // Any time we go traverse backwards, just let us
      if(currentForm.filter(".sp-calendar-tab").length){
        if(targetForm.filter(".sp-details-tab").length){
          direction = "BACKWARDS";
        }
      }

      if(direction === "BACKWARDS"){      
        return true;
      }

      if(currentForm.filter(".sp-details-tab").length){
        areInputsValid(true, (validResult)=>{
          handleInputsForDetailsTab(validResult, done);        
        });                   
      } else if(currentForm.filter(".sp-address-tab").length){
        areInputsValid(true, (validResult)=>{
          handleInputsFinishedValidatingForAddressTab(validResult, done);
        });
      } else if(currentForm.filter(".sp-calendar-tab").length){
        areInputsValid(true, (validResult)=>{
          handleInputsForCalendarTab(validResult, done);
        });
      } else{
        areInputsValid(true, done);
      }

      function handleInputsForCalendarTab(validResult, cb) {
        if(validResult) {
          let selectedRows = calendarTab.getCalendarShiftTimes();
          let wrongDays = [];
          Object.keys(selectedRows).forEach((key)=>{
            const timeFrom = selectedRows[key][0].from;
            const timeTo = selectedRows[key][0].to
            if(timeFrom == 'Invalid date' || timeTo == 'Invalid date'){
              wrongDays.push(key);
            } 
            if(timeFrom != 'Invalid date' && timeTo != 'Invalid date') {
              const fromMoment = convertMilitaryToInt(timeFrom);
              const toMoment = convertMilitaryToInt(timeTo);
              if(toMoment < fromMoment){
                wrongDays.push(key);
              }            
            }

          });
          if(wrongDays.length>0){
            calendarTab.showInvalidShiftError(wrongDays);
            cb(false);
          } else {
            $(".time-picker-error").css('display', 'none');
            cb(true);
          }         
        } else {
          cb(validResult);
        }

      }

      function areInputsValid(shouldContinue, cb) {
        let allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
        let notValid = !quickWizard.areInputsValid(allPrevInputs, {displayErrors: true});
        if(notValid || !shouldContinue){
          if(notValid){
            quickWizard.goToFirstIncompleteForm();
          }
          cb(false);
        } else {
          cb(true);
        }
      }

      function handleInputsFinishedValidatingForAddressTab(validResult, cb) {
          if(validResult){
            addressValidation.determineAddressValidity((useAddress) => {
              if(useAddress){
                // need below logic for edit flow
                //const validatedAddress = addressValidation.getAddressResponse();
                //hiddenAddressInput.val(JSON.stringify(validatedAddress));
                cb(true);
              }else{
                cb(false);
              }
            });
          } else {
            cb(validResult);
          }
      }
      function handleInputsForDetailsTab(validResult, cb){        
        if(validResult){
          let ownershipRadio = false;
          let selectBoxAndRadioFlag = false;
          let certificateSwitchEl = $(".certification-switch"); 

          //If facCode is invalid, do not allow user to navigate to next tab.
          if($("#dup-facCode").is(":visible")){
            cb(false); 
            return false;
          }

          //Ownership radio Validations
          $(".ownership-radio").each(function(){
            if($(this).is(":checked")){
              ownershipRadio = true;
            }
          });
          if(!ownershipRadio){
            $("#details-tab-fac-ownership-error").show();
            cb(false);
          }else{
            $("#details-tab-fac-ownership-error").hide();          
          }

          //Ownership select box Validations
          if($(".leased").is(":checked")){
            if($(".fac-leased-select").val()){
              selectBoxAndRadioFlag = true;
            }
          }else if($(".owned").is(":checked")){
            if($(".fac-owned-select").val()){
              selectBoxAndRadioFlag = true;
            }
          } 
          if(ownershipRadio && !selectBoxAndRadioFlag){
            $("#details-tab-fac-ownership-dropdown-error").show();
            cb(false);
          }else{
            $("#details-tab-fac-ownership-dropdown-error").hide();                          
          }
          
          //Facility Certifications Validations
          if(certificateSwitchEl.is(":checked")){
            let isvalid = true;
            $("input[name='certificate']").each(function() {             
              if($(this).val()==''){
                isvalid = false;   
              }
            });
            if(!isvalid){
              $("#facility-certifications-error").show();
              cb(false); 
            }else{
              $("#facility-certifications-error").hide();   
              cb(true);
            }
         }else if(selectBoxAndRadioFlag) {
          cb(true); 
         }           
      }else{
         cb(validResult);         
      }
    }
   
    return done;
  },
  didNavigateToForm: ({currentForm})=>{
    if(currentForm.filter('.sp-review-tab').length){
      reviewTab.fillReviewCalendarArea(calendarTab.getCalendarShiftTimes());
      reviewTab.fillReviewElementsWithVals();
    }
    return true;
  }

  });

  $("#cancel-url").on('click', function (){
    window.location.href = $(this).data('redirect-to-url');
  });

  $(document).on('click', "[data-target-form]", function(){
    const form = el.find($(this).data("target-form"));
    quickWizard.gotToForm(form);
  });

  quickWizard.init();
  const detailsTab = new DetailsTab(quickWizard);
  detailsTab.init();

  const addressTab = new AddressTab(quickWizard);
  addressTab.init();

  const operationsTab = new OperationsTab(quickWizard);
  operationsTab.init();

  const calendarTab = new CalendarTab(quickWizard);
  calendarTab.init();

  const reviewTab = new ReviewTab(quickWizard);
  reviewTab.init();

  const addressValidationModalEl = $("#add-validation-model");
  const addressValidation = addressValidationFactory(addressValidationModalEl, el, {
    isAlreadyValid: false
  });
}


// WEBPACK FOOTER //
// ./src/pages/standardPlatformFacilitySetupWizard/standardPlatformWizard.js